// Document
export enum TourType {
  FIX_END_TIME_TO = 0,
  FIX_START_TIME_BACK = 1
}
